import React from 'react';
import classes from './FormDialogue.module.css';
import Button from 'components/UI/Button/Button';

const formDialogue = (props) => {
  const FormDialogueWrapperClasses = [classes.FormDialogueWrapper, classes[props.className]];
  if (props.show === true) {
    FormDialogueWrapperClasses.push(classes.Shown);
  }

  let errorMessage = null;

  if (props.error) {
    errorMessage = <p className={classes.ErrorMessage}>{props.error.replace(/_/g, ' ')}</p>;
  }
  return (
    <div className={FormDialogueWrapperClasses.join(' ')}>
      <div className={classes.FormDialogueBackground} />
      <div className={classes.FormDialogueContainer}>
        <div className={classes.FormDialogue}>
          <div className={classes.Title}>
            <h3>{props.title}</h3>
          </div>
          {props.desc ? (
            <div className={classes.Description}>
              <p>{props.desc}</p>
            </div>
          ) : null}
          <div className={classes.FormFields}>
            {errorMessage}
            {props.children}
          </div>
          <div className={classes.Buttons}>
            {props.cancel ? (
              <div className={classes.CancelButton}>
                <Button btnType="CancelFormDialogue" clicked={props.cancel}>
                  {props.cancelText}
                </Button>
              </div>
            ) : null}
            {props.confirm ? (
              <div className={classes.ConfirmButton}>
                <Button btnType="ConfirmFormDialogue" clicked={props.confirm} disabled={props.disabled}>
                  {props.confirmText}
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default formDialogue;
